import React from "react";
import Overview from "./Overview";
import AllAdminsStats from "./AdminsStats";

export const ContentStats = () => {
  return (
    
      <Overview />
    
  );
};

export const AdminsStats = () => {
  return (
    
      <AllAdminsStats />
    
  );
};
